/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_discover_actions_liked = /** @type {(inputs: { id: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`프로젝트 ${i?.id}에 좋아요를 눌렀습니다`)
};

const en_discover_actions_liked = /** @type {(inputs: { id: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Liked project ${i?.id}`)
};

const ja_discover_actions_liked = /** @type {(inputs: { id: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクト${i?.id}にいいねしました`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ id: NonNullable<unknown> }} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const discover_actions_liked = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discover_actions_liked(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discover_actions_liked", locale)
	if (locale === "ko") return ko_discover_actions_liked(inputs)
	if (locale === "en") return en_discover_actions_liked(inputs)
	return ja_discover_actions_liked(inputs)
};